import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
// import Cookies from 'js-cookie'

const service = axios.create({
  baseURL: process.env.API_BASE_API,
  timeout: 40000
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    let token = localStorage.getItem('token')
    if(token && token !== '') {
      config.headers['Authorization'] = token
    }
    config.url = encodeURI(config.url)
    return config
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let response = error.response
    if (!response) {
      return Promise.reject(error)
    } else {
      let code = response.status
      if (code === 401 || code === 403) {
        Message({
          message: 'token异常，请重新登录',
          type: 'error'
        })
      } else if (code === 400) {
        Message({
          message: response.data.message,
          type: 'error'
        })
        return Promise.reject(response.data)
      } else if (code === 500) {
        router.push({ path: '/500' })
      } else {
        return Promise.reject(error)
      }
    }
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js